import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CajaDashboard from '../components/Dashboard/CajaDashboard';

// import TableMaterial from "../components/TableMaterial";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    paddingTop: "40px"
  },
  iconos: {
    color: "white",
  },
  container: {
    paddingTop: "40px",
    alignItems: "center",
  },
  containerGrafica: {
    marginTop: "40px",
  },
  containerTabla: {
    marginTop: "20px",
  },
  CardsHeader: {},
  actualizado: {
    textAlign: "center",
    marginTop: "-33px",
  },
  titulo: {
    fontSize: "20px",
    color: "#DF5900",
  },
}));



function Dashboard(props) {
  const classes = useStyles();
  return (
    <>
      <div className={classes.root}>
          <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
          <Grid item xs={12} className={classes.containerTabla}>
            <CajaDashboard />
          </Grid>
      </div>
    </>
  );
}

export default Dashboard;
